if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get optionFieldCount() {
      const fields = this.querySelectorAll(
        '.m-product-option select, .m-product-option input[type="radio"]'
      );

      const fieldNames = new Set();

      fields.forEach((field) => {
        const fieldName =
          field.name || field.dataset.fieldName;

        if (fieldName) {
          fieldNames.add(fieldName);
        }
      });

      return fieldNames.size;
    }

    get selectedOptionValues() {
      const fields = this.querySelectorAll(
        '.m-product-option select, .m-product-option input[type="radio"]'
      );

      const selectedValues = new Map();

      fields.forEach((field) => {
        const fieldName =
          field.name || field.dataset.fieldName;

        if (!fieldName) {
          return;
        }

        if (
          field.tagName.toLowerCase() === "select"
        ) {
          const selectedOption = Array.from(
            field.options
          ).find(
            (option) =>
              option.selected && !option.disabled
          );

          const optionValueId =
            selectedOption?.dataset.optionValueId;

          if (optionValueId) {
            selectedValues.set(
              fieldName,
              optionValueId
            );
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio" &&
          field.checked
        ) {
          const optionValueId =
            field.dataset.optionValueId;

          if (optionValueId) {
            selectedValues.set(
              fieldName,
              optionValueId
            );
          }
        }
      });

      return Array.from(selectedValues.values());
    }

    connectedCallback() {
      this.addEventListener(
        "change",
        (event) => {
          const selectedOptionValues =
            this.selectedOptionValues;

          /*
           * Do not resolve a Shopify variant until
           * the customer has chosen every option.
           */
          if (
            selectedOptionValues.length !==
            this.optionFieldCount
          ) {
            return;
          }

          const target =
            this.getInputForEventTarget(
              event.target
            );

          MinimogEvents.emit(
            MinimogTheme.pubSubEvents
              .optionValueSelectionChange,
            {
              data: {
                selectedOptionValues,
                event,
                target,
              },
            }
          );
        }
      );
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT"
        ? target.selectedOptions[0]
        : target;
    }
  }

  customElements.define(
    "variant-picker",
    VariantPicker
  );
}